export class GenericModalData {
	title: string;
	paragrafi: Array<string>;
	azioni: Array<Azione>;
}

export class Azione {
	testo: string;
	effetto: Function;

	constructor(testo: string, effetto: Function = () => { }) {
		this.testo = testo;
		this.effetto = effetto;
	}
}